import type { EmbedCapability } from '@responsedock/types';

export function allowedEmbedNavigation(
  path: string,
  role: 'admin' | 'respondent',
  capabilities?: EmbedCapability[],
): boolean {
  if (role === 'respondent') return path === '/embedded/surveys';
  if (!capabilities) {
    return /^\/(?:embedded\/admin|surveys(?:\/new\/ai|\/[^/]+\/(?:edit|analytics|responses))?|templates|intelligence)$/.test(path);
  }
  if (path === '/embedded/admin') return capabilities.includes('questionnaire:view');
  if (/^\/surveys\/[^/]+\/edit$/.test(path)) return capabilities.includes('questionnaire:edit');
  if (/^\/surveys\/[^/]+\/(?:analytics|responses)$/.test(path)) return capabilities.includes('results:view');
  return false;
}
